<template lang="html">
<div class="section">
  <div class="container has-text-centered">
    <p>You have been logged out.</p>
    <b-field>
      <b-button
        class="is-light"
        v-on:click="$router.push({ name: 'login' })">
        Login
      </b-button>
    </b-field>

    <div v-if="errorMsg !== ''">
      <p>Something went wrong!</p>
      <p>{{ errorMsg }}</p>
    </div>
  </div>
</div>
</template>

<script>
import { AUTH_LOGOUT_REQUEST } from '@/store/actions/auth'

export default {
  data () {
    return {
      errorMsg: ''
    }
  },
  methods: {
    logout () {
      this.$store.dispatch(AUTH_LOGOUT_REQUEST)
        .then(() => {
          console.log('logout')
        })
        .catch((error) => {
          if (error.response) {
            console.log(error.response)
            this.errorMsg = error.response.data
          } else {
            console.log(error)
            this.errorMsg = error
          }
        })
    }
  },
  mounted () {
    this.logout()
  }
}
</script>
